<template>
  <div class="relative bg-gray-50 overflow-hidden min-h-screen">
    <div class="hidden sm:block sm:absolute sm:inset-y-0 sm:h-full sm:w-full">
      <div class="relative h-full max-w-screen-xl mx-auto">
        <svg
          class="absolute right-full transform translate-y-1/4 translate-x-1/4 lg:translate-x-1/2"
          width="404"
          height="784"
          fill="none"
          viewBox="0 0 404 784"
        >
          <defs>
            <pattern
              id="f210dbf6-a58d-4871-961e-36d5016a0f49"
              x="0"
              y="0"
              width="20"
              height="20"
              patternUnits="userSpaceOnUse"
            >
              <rect
                x="0"
                y="0"
                width="4"
                height="4"
                class="text-gray-200"
                fill="currentColor"
              />
            </pattern>
          </defs>
          <rect
            width="404"
            height="784"
            fill="url(#f210dbf6-a58d-4871-961e-36d5016a0f49)"
          />
        </svg>
        <svg
          class="absolute left-full transform -translate-y-3/4 -translate-x-1/4 md:-translate-y-1/2 lg:-translate-x-1/2"
          width="404"
          height="784"
          fill="none"
          viewBox="0 0 404 784"
        >
          <defs>
            <pattern
              id="5d0dd344-b041-4d26-bec4-8d33ea57ec9b"
              x="0"
              y="0"
              width="20"
              height="20"
              patternUnits="userSpaceOnUse"
            >
              <rect
                x="0"
                y="0"
                width="4"
                height="4"
                class="text-gray-200"
                fill="currentColor"
              />
            </pattern>
          </defs>
          <rect
            width="404"
            height="784"
            fill="url(#5d0dd344-b041-4d26-bec4-8d33ea57ec9b)"
          />
        </svg>
      </div>
    </div>

    <div class="relative flex items-center min-h-screen">
      <div
        class="mt-10 mx-auto max-w-screen-xl px-4 sm:mt-12 sm:px-6 md:mt-16 lg:mt-20 xl:mt-28 relative"
      >
        <div class="flex items-center justify-center w-full flex-wrap">
          <div class="flex items-center justify-around">
            <img
              src="../assets/iluarco.png"
              alt=""
              class="w-24 m-3 md:m-6"
            />
            <img
              src="../assets/suma-verde.png"
              alt=""
              class="w-24 m-3 md:m-6"
            />
          </div>
        </div>
        <div class="text-center">
          <h2
            class="text-4xl tracking-tight leading-10 font-extrabold text-gray-900 sm:text-3xl sm:leading-none md:text-5xl lg:text-5xl xl:text-5xl xl:mx-40 lg:mx-32"
          >
            ¿Te interesa saber el
            <br class="xl:hidden lg:hidden" />
            <span class="text-suma">impacto ambiental</span>
            y la carga térmica de tu proyecto?
          </h2>
          <p
            class="mt-3 max-w-md mx-auto text-base text-gray-500 sm:text-lg md:mt-5 md:text-xl md:max-w-3xl"
          >
            Bienvenido a Suma Verde, aquí podrás conocer los detalles
            ambientales de tu construcción, solo es necesario que llenes los
            datos y después de unos sencillos pasos, recibirás un correo con los
            pormenores de tu proyecto.
          </p>
          <div class="mx-auto mt-15 flex flex-col sm:flex-row items-center" style="max-width: max-content;">
            <div class="m-2 rounded-md shadow mx-10" style="width:200px;">
              <a
                class="text-2xl w-full h-full flex items-center justify-center px-8 py-3 border border-transparent text-base leading-6 font-medium rounded-md text-white bg-suma hover:bg-indigo-500 focus:outline-none focus:shadow-outline-indigo transition duration-150 ease-in-out md:py-4 md:px-10"
                href="/Instructivo_Suma_Verde.pdf"
                download
              >
                Instructivo
              </a>
            </div>
            <div class="m-2 rounded-md shadow mx-10" style="width:200px;">
              <button
                type="button"
                @click="$emit('start')"
                class="text-2xl w-full h-full flex items-center justify-center px-8 py-3 border border-transparent text-base leading-6 font-medium rounded-md text-white bg-suma hover:bg-indigo-500 focus:outline-none focus:shadow-outline-indigo transition duration-150 ease-in-out md:py-4 md:px-10"
              >
                ¿Empezamos?
              </button>
            </div>
            <div class="m-2 rounded-md shadow relative sm:fixed" style="right: 0px; top: 0px;">
              <button
                type="button"
                @click="openLibrary"
                class="text-2xl w-full h-full flex items-center justify-center px-8 py-3 border border-transparent text-base leading-6 font-medium rounded-md text-white bg-suma hover:bg-indigo-500 focus:outline-none focus:shadow-outline-indigo transition duration-150 ease-in-out sm:py-1 sm:px-1 sm:text-xl "
              >
                Biblioteca de materiales
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
      <materials-library-modal
        ref="materialsLibraryModal"
        type="success"
        title="Información enviada correctamente"
        text="Hemos recibido su información correctamente. Te enviaremos un correo con los resultados."
        action-text="Aceptar"
      ></materials-library-modal>
  </div>
</template>

<script>
export default {
  methods: {
    openLibrary(){
      this.$refs.materialsLibraryModal.open();
    }
  }
};
</script>
